
import { useTranslation } from 'react-i18next';

export default function ServicesList() {
  const { t } = useTranslation('services');

  const services = [
    {
      id: 'gas',
      icon: 'ri-fire-line',
      titleKey: 'gas.title',
      categories: [
        {
          titleKey: 'gas.smallBusiness.title',
          items: [
            'gas.smallBusiness.rights',
            'gas.smallBusiness.checklist'
          ]
        },
        {
          titleKey: 'gas.otherBusiness.title',
          items: [
            'gas.otherBusiness.rights',
            'gas.otherBusiness.checklist'
          ]
        },
        {
          titleKey: 'gas.households.title',
          items: [
            'gas.households.rights',
            'gas.households.checklist'
          ]
        }
      ]
    },
    {
      id: 'electricity',
      icon: 'ri-flashlight-line',
      titleKey: 'electricity.title',
      categories: [
        {
          titleKey: 'electricity.smallBusiness.title',
          items: [
            'electricity.smallBusiness.rights',
            'electricity.smallBusiness.checklist',
            'electricity.smallBusiness.environmental',
            'electricity.smallBusiness.impact'
          ]
        },
        {
          titleKey: 'electricity.otherBusiness.title',
          items: [
            'electricity.otherBusiness.rights',
            'electricity.otherBusiness.checklist',
            'electricity.otherBusiness.environmental',
            'electricity.otherBusiness.impact'
          ]
        },
        {
          titleKey: 'electricity.households.title',
          items: [
            'electricity.households.rights',
            'electricity.households.checklist'
          ]
        }
      ]
    },
    {
      id: 'consulting',
      icon: 'ri-building-line',
      titleKey: 'consulting.title',
      categories: [
        {
          titleKey: 'consulting.services.title',
          items: [
            'consulting.services.strategic',
            'consulting.services.operational',
            'consulting.services.compliance',
            'consulting.services.market'
          ]
        }
      ]
    }
  ];

  return (
    <section className="py-20 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#0D1B2A] mb-4 tracking-tight">
            {t('list.title', 'Our Service Categories')}
          </h2>
          <p className="text-xl text-[#394B59] max-w-3xl mx-auto leading-relaxed">
            {t('list.subtitle', 'Professional energy solutions tailored to your business needs')}
          </p>
        </div>

        <div className="space-y-12">
          {services.map((service) => (
            <div key={service.id} className="bg-white rounded-2xl p-8 shadow-sm">
              <div className="flex items-center mb-8">
                <div className="w-16 h-16 bg-[#0D1B2A] rounded-xl flex items-center justify-center mr-6">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-[#0D1B2A]">
                  {t(service.titleKey, service.id.toUpperCase())}
                </h3>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                {service.categories.map((category, categoryIndex) => (
                  <div key={categoryIndex} className="bg-[#F5F7FA] rounded-xl p-6">
                    <h4 className="text-lg font-semibold text-[#0D1B2A] mb-4">
                      {t(category.titleKey, 'Category')}
                    </h4>
                    <ul className="space-y-3">
                      {category.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="flex items-start space-x-3">
                          <i className="ri-check-line text-[#2E8BC0] text-sm mt-1 flex-shrink-0"></i>
                          <span className="text-sm text-[#394B59] leading-relaxed">
                            {t(item, 'Service information')}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
